import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';

import CustomButtonGroup from '../CustomButtonGroup/CustomButtonGroup';

const CustomDialog = ({open, toggleOff, dialogTitle, dialogContent, DialogIcon, actionButtons}) => {
  return (
    <Dialog
      open={open}
      onClose={toggleOff}
      sx={{
        '& .MuiDialog-paper': {
          p: 0.5,
        },
      }}
    >
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent sx={{display: 'flex', alignItems: 'center'}}>
        {DialogIcon && (
          <Box sx={{pr: 2}}>
            <DialogIcon />
          </Box>
        )}
        <DialogContentText>{dialogContent}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {Array.isArray(actionButtons) && actionButtons.length > 1 && (
          <CustomButtonGroup
            first={{
              ...actionButtons[0],
            }}
            second={{
              ...actionButtons[1],
            }}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
